/* eslint-disable no-unused-vars */
import '../sass/style.scss';
import Slideout from 'slideout';
import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
import 'swiper/swiper.scss';

// eslint-disable-next-line import/no-duplicates
import moment from 'jalali-moment';
// import _ from 'lodash';
import regeneratorRuntime from 'regenerator-runtime';
import typeAhead from './modules/typeAhead';
import catbrandingFitler from './modules/brandfilteringCat';
import subcatbrandingFitler from './modules/brandfilteringSubCat';
import { $, $$ } from './modules/bling';
import printMe from './print.js';
import filter from './modules/filter';

// protect image download
const images = document.querySelectorAll('img');
console.log(images);
images.forEach((img) => {
  img.addEventListener('contextmenu', (e) => {
    if (e.button === 2) {
      e.preventDefault();
    }
  });
});

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Lazy]);

const slideout = new Slideout({
  panel: document.getElementById('panel'),
  menu: document.getElementById('menu'),
  side: 'right',
  padding: 256,
  tolerance: 70,
});

window.slideout = slideout;

const toggleMenu = document.querySelector('.toggle-button');
toggleMenu.addEventListener('click', () => {
  slideout.toggle();
});

// eslint-disable-next-line no-inner-declarations
function close(eve) {
  eve.preventDefault();
  slideout.close();
}
// eslint-enable-next-line no-inner-declarations

slideout
  .on('beforeopen', function () {
    this.panel.classList.add('panel-open');
  })
  .on('open', function () {
    this.panel.addEventListener('click', close);
  })
  .on('beforeclose', function () {
    this.panel.classList.remove('panel-open');
    this.panel.removeEventListener('click', close);
  });

const fixed = document.querySelector('.fixed-header');
const header = document.querySelector('header');

slideout.on('translate', function (translated) {
  fixed.style.transform = `translateX(${translated}px)`;
});

slideout.on('beforeopen', function () {
  fixed.style.transition = 'transform 300ms ease';
  header.style.transition = 'transform 300ms ease';
  fixed.style.transform = 'translateX(0)';
  // position stickers when slide open
  const audio = document.querySelector('audio');
  if (audio) {
    audio.style.transform = 'translateX(-256px)';
    audio.style.transition = 'transform 300ms ease';
  }
  // const rayChatBox = document.querySelector('.raychat_main_button.right');
  const callUsNow = document.getElementById('call-us-wrapper');
  // if (rayChatBox) {
  //   rayChatBox.style.transform = 'translateX(256px)';
  //   rayChatBox.style.transition = 'transform 300ms ease';
  // }

  callUsNow.style.transform = 'translateX(-256px)';
  callUsNow.style.transition = 'transform 300ms ease';
});

slideout.on('beforeclose', function () {
  const audio = document.querySelector('audio');
  if (audio) {
    audio.style.transform = 'translateX(0px)';
  }
  fixed.style.transition = 'transform 300ms ease';
  header.style.transition = 'transform 300ms ease';
  fixed.style.transform = 'translateX(0px)';
});

slideout.on('open', function () {
  fixed.style.transition = '';
  header.style.transition = '';
});

slideout.on('close', function () {
  fixed.style.transition = '';
  header.style.transition = '';

  // position stickers when slide open
  // const rayChatBox = document.querySelector('.raychat_main_button.right');
  const callUsNow = document.getElementById('call-us-wrapper');
  callUsNow.style.transform = 'translateX(0px)';
  callUsNow.style.transition = 'transform 300ms ease';
  // rayChatBox.style.transform = 'translateX(0px)';
  // rayChatBox.style.transition = 'transform 300ms ease';
});

// menu dropdown

const submenus = Array.from(document.querySelectorAll('.sub-menus'));
if (window.matchMedia('(max-width: 900px)').matches) {
  submenus.forEach((sub) => {
    sub.style.visibility = 'hidden';
    sub.style.height = '0';
    sub.style.transform = 'scaleY(0)';
    sub.style.transformOrigin = 'top';
  });
}
function up(sub) {
  const li = sub.parentElement;
  const svg = li.querySelector('svg');
  svg.style.transform = 'rotate(180deg)';
  svg.style.transition = 'all 250ms';
}

function down(sub) {
  const li = sub.parentElement;
  const svg = li.querySelector('svg');
  svg.style.transform = 'rotate(0deg)';
  svg.style.transition = 'height 250ms';
}
submenus.forEach((sub) => {
  const li = sub.parentElement;

  const anchor = li.querySelector('a');
  if (window.matchMedia('(max-width: 900px)').matches) {
    anchor.addEventListener('click', () => {
      const ul = anchor.nextElementSibling.style;
      if (ul.visibility === 'hidden') {
        ul.height = `auto`;
        ul.transform = 'scaleY(1)';
        ul.visibility = 'visible';
        ul.transition = 'all 250ms';
        ul.transformOrigin = 'top';
        up(sub);
      } else {
        ul.transformOrigin = 'top';
        ul.visibility = 'hidden';
        ul.height = '0';
        ul.transition = 'all 250ms';
        ul.transform = `scaleY(0)`;
        down(sub);
      }
    });
  }
});

const menuLvlOne = document.querySelector('.lvlone');
const urls = menuLvlOne.querySelectorAll('a');

// eslint-disable-next-line no-plusplus
for (let i = 0; i < urls.length; i++) {
  if (urls[i].nextElementSibling) {
    urls[i].addEventListener('click', (e) => {
      e.preventDefault();
    });
  }
}

// slider main page //

// // configure Swiper to use modules
// SwiperCore.use([Navigation, Pagination, Lazy]);

// eslint-disable-next-line no-unused-vars
const mySwiper = new Swiper('.swiper-slider-top-page', {
  // Optional parameters
  // direction: 'horizontal',
  slidesPerView: 1,
  loop: true,
  lazy: true,
  watchSlidesVisibility: true,
  // Disable preloading of all images
  // lazy: true,
  // spaceBetween: 10,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
});
// eslint-enable-next-line no-unused-vars

// slider links //

// eslint-disable-next-line no-unused-vars
const swiperLinks = new Swiper('.swiper-slider-links', {
  // Optional parameters
  slidesPerView: 2,
  direction: 'horizontal',
  loop: false,
  spaceBetween: 10,
  lazy: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
  breakpoints: {
    410: {
      slidesPerView: 3,
    },
    710: {
      slidesPerView: 4,
      navigation: false,
    },
    910: {
      slidesPerView: 4,
      centeredSlidesBounds: true,
      navigation: false,
    },
  },
});
// eslint-enable-next-line no-unused-vars

// eslint-disable-next-line no-unused-vars
const swiperBrands = new Swiper('.swiper-slider-brands', {
  // Optional parameters
  slidesPerView: 2,
  direction: 'horizontal',
  loop: false,
  spaceBetween: 10,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
  breakpoints: {
    450: {
      slidesPerView: 3,
    },
    900: {
      slidesPerView: 5,
    },
    1200: {
      slidesPerView: 7,
    },
    1500: {
      slidesPerView: 8,
    },
    1700: {
      slidesPerView: 9,
    },
  },
});

// eslint-disable-next-line no-unused-vars
const swiperLastestProducts = new Swiper('.lastest-product-slider-wrapper', {
  // Optional parameters
  slidesPerView: 8,
  direction: 'horizontal',
  loop: false,
  spaceBetween: 10,
  lazy: true,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
});

// eslint-disable-next-line no-unused-vars
const swiperMostViewdArticles = new Swiper(
  '.swiper-slider-most-viewed-aricles',
  {
    slidesPerView: 'auto',
    direction: 'vertical',
    spaceBetween: 10,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // breakpoints: {
    //   450: {
    //     slidesPerView: 3,
    //   },
    //   900: {
    //     slidesPerView: 5,
    //   },
    //   1200: {
    //     slidesPerView: 6,
    //   },
    //   1500: {
    //     slidesPerView: 7,
    //   },
    //   1700: {
    //     slidesPerView: 9,
    //   },
    // },
  }
);

// eslint-disable-next-line no-unused-vars
const swiperLastArticles = new Swiper('.swiper-slider-last-aricles', {
  // Optional parameters
  slidesPerView: 'auto',
  direction: 'vertical',
  spaceBetween: 10,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  // breakpoints: {
  //   450: {
  //     slidesPerView: 3,
  //   },
  //   900: {
  //     slidesPerView: 5,
  //   },
  //   1200: {
  //     slidesPerView: 6,
  //   },
  //   1500: {
  //     slidesPerView: 7,
  //   },
  //   1700: {
  //     slidesPerView: 9,
  //   },
  // },
});
// eslint-enable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
const swiperLastVideos = new Swiper('.swiper-slider-last-videos', {
  slidesPerView: 'auto',
  direction: 'vertical',
  spaceBetween: 10,
  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    450: {
      slidesPerView: 3,
    },
    900: {
      slidesPerView: 5,
    },
    1200: {
      slidesPerView: 6,
    },
    1500: {
      slidesPerView: 7,
    },
    1700: {
      slidesPerView: 9,
    },
  },
});
// eslint-enable-next-line no-unused-vars

// eslint-disable-next-line no-unused-vars
// const swiperProductSlider1 = new Swiper('.related-products-mobile', {
//   slidesPerView: 'auto',
//   spaceBetween: 10,
//   direction: 'horizontal',
//   loop: false,
//   lazy: true,
//   freeMode: true,
//   nextButton: false,
//   prevButton: false,
//   watchSlidesProgress: true,
// });

const swiperProductRelatedArticlsSlider1 = new Swiper(
  '.related-articles-desktop',
  {
    slidesPerView: 1,
    spaceBetween: 10,
    direction: 'horizontal',
    loop: false,
    lazy: true,
    freeMode: true,
    nextButton: false,
    prevButton: false,
    watchSlidesProgress: true,
  }
);

const swiperRelatedProductSwiperSlider = new Swiper(
  '.swiper-mobile-slider-related-products',
  {
    slidesPerView: 'auto',
    spaceBetween: 10,
    direction: 'horizontal',
    loop: false,
    freeMode: true,
    lazy: true,
    nextButton: false,
    prevButton: false,
    watchSlidesProgress: true,
    breakpoints: {
      900: {
        freeMode: false,
        slidesPerView: 4,
        spaceBetween: 30,
        lazy: true,
        nextButton: true,
        prevButton: true,
      },
      130: {
        freeMode: false,
        slidesPerView: 5,
        spaceBetween: 30,
        nextButton: true,
        lazy: true,
        prevButton: true,
      },
      1250: {
        freeMode: false,
        slidesPerView: 6,
        spaceBetween: 30,
        nextButton: true,
        lazy: true,
        prevButton: true,
      },
      1500: {
        freeMode: false,
        slidesPerView: 7,
        spaceBetween: 30,
        nextButton: true,
        lazy: true,
        prevButton: true,
      },
      1700: {
        freeMode: false,
        slidesPerView: 8,
        spaceBetween: 30,
        nextButton: true,
        prevButton: true,
        lazy: true,
        centeredSlidesBounds: true,
      },
    },
  }
);

const SLIDER_AMOUNT = 20;
if (window.matchMedia('(min-width: 900px)').matches) {
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < SLIDER_AMOUNT; i++) {
    const swiperProductSettings = {
      slidesPerView: 'auto',
      spaceBetween: 10,
      direction: 'horizontal',
      loop: false,
      freeMode: true,
      lazy: true,
      nextButton: false,
      prevButton: false,
      watchSlidesProgress: true,
      breakpoints: {
        900: {
          freeMode: false,
          slidesPerView: 4,
          spaceBetween: 30,
          lazy: true,
          nextButton: true,
          prevButton: true,
          navigation: {
            nextEl: `.swiper-button-next-${i}`,
            prevEl: `.swiper-button-prev-${i}`,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        1300: {
          freeMode: false,
          slidesPerView: 5,
          spaceBetween: 30,
          nextButton: true,
          lazy: true,
          prevButton: true,
          navigation: {
            nextEl: `.swiper-button-next-${i}`,
            prevEl: `.swiper-button-prev-${i}`,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        1250: {
          freeMode: false,
          slidesPerView: 6,
          spaceBetween: 30,
          nextButton: true,
          lazy: true,
          prevButton: true,
          navigation: {
            nextEl: `.swiper-button-next-${i}`,
            prevEl: `.swiper-button-prev-${i}`,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        1500: {
          freeMode: false,
          slidesPerView: 7,
          spaceBetween: 30,
          nextButton: true,
          lazy: true,
          prevButton: true,
          navigation: {
            nextEl: `.swiper-button-next-${i}`,
            prevEl: `.swiper-button-prev-${i}`,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
        1700: {
          freeMode: false,
          slidesPerView: 8,
          spaceBetween: 30,
          nextButton: true,
          prevButton: true,
          lazy: true,
          centeredSlidesBounds: true,
          navigation: {
            nextEl: `.swiper-button-next-${i}`,
            prevEl: `.swiper-button-prev-${i}`,
          },
          pagination: {
            el: '.swiper-pagination',
          },
        },
      },
    };

    const prev = document.querySelector(`.swiper-button-prev-${i}`);
    const next = document.querySelector(`.swiper-button-next-${i}`);
    if (prev || next) {
      prev.style.position = 'absolute';
      prev.style.top = '50%';
      prev.style.left = '0';

      next.style.position = 'absolute';
      next.style.top = '50%';
      next.style.right = '0';
    }

    const sliderFirstPage = new Swiper(
      `.swiper-product-slider-${i}`,
      swiperProductSettings
    );
  }
} else {
  for (let i = 0; i < SLIDER_AMOUNT; i++) {
    const swiperProductSettings = {
      slidesPerView: 'auto',
      spaceBetween: 10,
      direction: 'horizontal',
      loop: false,
      freeMode: true,
      lazy: true,
      nextButton: false,
      prevButton: false,
      watchSlidesProgress: true,
    };

    const sliderFirstPage = new Swiper(
      `.swiper-product-slider-${i}`,
      swiperProductSettings
    );
  }
}

const swiperProductPageSlider = new Swiper('.swiper-product-page-slider', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  direction: 'horizontal',
  loop: false,
  lazy: true,
  pagination: {
    el: '.swiper-pagination',
  },
  freeMode: false,
  nextButton: true,
  prevButton: true,
  watchSlidesProgress: true,
});
// eslint-enable-next-line no-unused-vars

// eslint-disable-next-line no-unused-vars
const swiperProductVideoSlider = new Swiper('.swiper-video-product-slider', {
  slidesPerView: '1',
  spaceBetween: 30,
  lazy: true,
  direction: 'horizontal',
  pagination: {
    el: '.swiper-pagination',
  },
  watchOverflow: true,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev',
  },
});
// eslint-enable-next-line no-unused-vars

// eslint-disable-next-line no-unused-vars
const swiperProductVideoSliderDesktop = new Swiper(
  '.swiper-video-product-slider-desktop',
  {
    slidesPerView: '2',
    spaceBetween: 30,
    freeMode: true,
    direction: 'vertical',
  }
);
// eslint-enable-next-line no-unused-vars

// validation register form //

const phoneMsg = document.querySelector('.phonenumber');
const passwordMsg = document.querySelector('.password');
const firstname = document.querySelector('.firstname');
const lastname = document.querySelector('.lastname');
const address = document.querySelector('.address');
const phoneline = document.querySelector('.phoneline');
const addressField = document.getElementById('address');
const phonelineField = document.getElementById('phoneline');
const companyname = document.querySelector('.companyname');
const firstnameField = document.getElementById('firstname');
const lastnameField = document.getElementById('lastname');
const companynameField = document.getElementById('companyname');
const minPassCharMsg = document.querySelector('.min-char-password');
const confirmedPassdMsg = document.querySelector('.confirmed-pass');
const phoneField = document.getElementById('phoneNo');
const passField = document.getElementById('password');
const confirmedPassField = document.getElementById('confirmed-pass');
const email = document.querySelector('.email');
const emailField = document.getElementById('email');
const faxField = document.getElementById('fax');
const websiteField = document.getElementById('website');
const subjectField = document.getElementById('subject');
const subject = document.querySelector('.subject');
const ticketDescField = document.getElementById('ticketDesc');
const ticketDesc = document.querySelector('.ticketDesc');

if (websiteField && websiteField.value) {
  websiteField.classList.add('alright-display');
}

if (faxField && faxField.value) {
  faxField.classList.add('alright-display');
}

if (emailField) {
  if (email) {
    emailField.classList.add('error-display');
  } else if (emailField.value === '') {
    emailField.classList.remove('error-display');
  } else {
    emailField.classList.add('alright-display');
  }
}

if (addressField) {
  if (address) {
    addressField.classList.add('error-display');
  } else if (addressField.value === '') {
    addressField.classList.remove('error-display');
  } else {
    addressField.classList.add('alright-display');
  }
}

if (subjectField) {
  if (subject) {
    subjectField.classList.add('error-display');
  } else if (subjectField.value === '') {
    subjectField.classList.remove('error-display');
  } else {
    subjectField.classList.add('alright-display');
  }
}

if (ticketDescField) {
  if (ticketDesc) {
    ticketDescField.classList.add('error-display');
  } else if (ticketDescField.value === '') {
    ticketDescField.classList.remove('error-display');
  } else {
    ticketDescField.classList.add('alright-display');
  }
}

if (phonelineField) {
  if (phoneline) {
    phonelineField.classList.add('error-display');
  } else if (phonelineField.value === '') {
    phonelineField.classList.remove('error-display');
  } else {
    phonelineField.classList.add('alright-display');
  }
}

if (companynameField) {
  if (companyname) {
    companynameField.classList.add('error-display');
  } else if (companynameField.value === '') {
    companynameField.classList.remove('error-display');
  } else {
    companynameField.classList.add('alright-display');
  }
}

if (lastnameField) {
  if (lastname) {
    lastnameField.classList.add('error-display');
  } else if (lastnameField.value === '') {
    lastnameField.classList.remove('error-display');
  } else {
    lastnameField.classList.add('alright-display');
  }
}

if (firstnameField) {
  if (firstname) {
    firstnameField.classList.add('error-display');
  } else if (firstnameField.value === '') {
    firstnameField.classList.remove('error-display');
  } else {
    firstnameField.classList.add('alright-display');
  }
}

if (phoneField) {
  if (phoneMsg) {
    phoneField.classList.add('error-display');
  } else if (phoneField.value === '') {
    phoneField.classList.remove('error-display');
  } else {
    phoneField.classList.add('alright-display');
  }
}

if (passField) {
  if (passwordMsg) {
    passField.classList.add('error-display');
  } else if (passField.value === '') {
    passField.classList.remove('error-display');
  } else {
    passField.classList.add('alright-display');
  }
}

if (confirmedPassField) {
  if (confirmedPassdMsg) {
    confirmedPassField.classList.add('error-display');
  } else if (confirmedPassField.value === '') {
    confirmedPassField.classList.remove('error-display');
  } else {
    confirmedPassField.classList.add('alright-display');
  }
}

if (minPassCharMsg) {
  confirmedPassField.classList.add('error-display');
  passField.classList.add('error-display');
  confirmedPassField.classList.remove('alright-display');
  passField.classList.remove('alright-display');
}

// const fixedHeader = document.querySelector('.fixed-header');
const wrapperHeader = document.querySelector('.section-wrapper');
// const fixedIt = document.querySelector('fixed-it');
wrapperHeader.classList.remove('fixed-header');
slideout.on('beforeopen', function () {
  header.style.transition = 'transform 300ms ease';
  header.style.transform = 'translateX(-256px)';
});
slideout.on('beforeclose', function () {
  header.style.transition = 'transform 300ms ease';
  header.style.transform = 'none';
});

// sticky navbar on scroll
const navbarOnScroll = document.querySelector('.navbar-on-scroll');
const panel = document.getElementById('panel');
const sticky = navbarOnScroll.offsetTop;

function stickyScroll() {
  if (window.pageYOffset >= sticky) {
    navbarOnScroll.classList.add('sticky');
    panel.style.paddingTop = '65px';
  } else {
    navbarOnScroll.classList.remove('sticky');
    panel.style.paddingTop = '1em';
  }
}

if (window.matchMedia('(max-width: 900px)').matches) {
  window.onscroll = function () {
    stickyScroll();
  };
}

// product accordian

const accordianBtn = document.querySelectorAll('.accordian');

// eslint-disable-next-line no-plusplus
for (let i = 0; i < accordianBtn.length; i++) {
  accordianBtn[i].addEventListener('click', function handleOpenAccordian() {
    this.classList.toggle('active-accordian');
    const panelProduct = this.nextElementSibling;
    if (panelProduct.style.maxHeight) {
      panelProduct.style.maxHeight = null;
    } else {
      panelProduct.style.maxHeight = `${panelProduct.scrollHeight}px`;
    }
  });
}

typeAhead($('#search'));

// pop on window

const parsePopupLs = JSON.parse(localStorage.getItem('popup'));
const gotItButton = document.querySelector('.got-it-button');
let closeWrapperTobtn = document.querySelector('#popup-wrapper');

function expiryDateFunc(timestamp, exp) {
  if (exp - timestamp >= 3600000) {
    localStorage.removeItem('popup');
  }
}
if (gotItButton || closeWrapperTobtn) {
  if (parsePopupLs) {
    // gotItButton.closest('#popup-wrapper').classList.add('display-on-window');
    const exp = new Date().getTime();
    const { timestamp } = parsePopupLs;
    expiryDateFunc(timestamp, exp);

    if (parsePopupLs.popupModal === 'cancelled') {
      closeWrapperTobtn.remove();
    }
  } else {
    gotItButton.closest('#popup-wrapper').classList.add('display-on-window');
    closeWrapperTobtn = document.querySelector('.display-on-window');
  }

  const handleClickOutside = (e) => {
    if (e.currentTarget === e.target) {
      closeWrapperTobtn.remove();
    }
  };

  gotItButton.addEventListener('click', handleClickOutside);
  closeWrapperTobtn.addEventListener('click', handleClickOutside);

  const handleLocalStorage = () => {
    const setItemLS = {
      popupModal: 'cancelled',
      timestamp: new Date().getTime(),
    };
    localStorage.setItem('popup', JSON.stringify(setItemLS));

    closeWrapperTobtn.remove();
  };

  gotItButton.on('click', handleLocalStorage);
}

// back to the last pag

const backHistory = document.querySelector('.back-button');

if (backHistory) {
  const handleHistoryBrowser = () => {
    window.history.back();
  };

  backHistory.addEventListener('click', handleHistoryBrowser);
}

// right click disable

// window.addEventListener(
//   'contextmenu',
//   function (e) {
//     e.preventDefault();
//   },
//   false
// );

// brand ajax

// const buttonBrands = document.querySelectorAll('.brand');
// const formBrand = document.querySelector('.brand-filter-inner');
// for (let i = 0; i < buttonBrands.length; i++) {
//   const buttonBrand = buttonBrands[i];
//   buttonBrand.on('click', brand);
// }

const dateInJalaali = document.querySelectorAll('.createdDate');
if (dateInJalaali) {
  dateInJalaali.forEach(function (singleDate) {
    const dateInText = singleDate.textContent;
    const event = new Date(dateInText);
    let date = JSON.stringify(event);
    date = date.slice(1, 26).replace('T', ' ').replace('"', '');
    singleDate.innerHTML = moment
      .from(`${date}`, 'YYYY-M-D HH:mm')
      .locale('fa')
      .fromNow();
    singleDate.classList.remove('hidden');
  });
}

let tabPanels;
let tabButtons;
const tabs = document.querySelector('.tabs');
if (tabs) {
  tabButtons = tabs.querySelectorAll('[role="tab"]');
  tabPanels = Array.from(tabs.querySelectorAll('[role="tabpanel"]'));
}

function handleTabClick(event) {
  // hide all tab panels
  tabPanels.forEach((panelForTabs) => {
    panelForTabs.hidden = true;
  });
  // mark all tabs as unselected
  tabButtons.forEach((tab) => {
    // tab.ariaSelected = false;
    tab.setAttribute('aria-selected', false);
  });
  // mark the clicked tab as selected
  event.currentTarget.setAttribute('aria-selected', true);
  // find the associated tabPanel and show it!
  const { id } = event.currentTarget;
  const tabPanel = tabPanels.find(
    (panelForTabs) => panelForTabs.getAttribute('aria-labelledby') === id
  );
  tabPanel.hidden = false;
}

if (tabButtons) {
  tabButtons.forEach((button) =>
    button.addEventListener('click', handleTabClick)
  );
}

const brandCatButton = document.querySelectorAll('.brand-cat');
const brandSubCatButton = document.querySelectorAll('.brand-subcat');

brandCatButton.forEach((button) => {
  button.addEventListener('click', catbrandingFitler);
});

brandSubCatButton.forEach((button) => {
  button.addEventListener('click', subcatbrandingFitler);
});

// animated product photos

// const productLinks = document.querySelectorAll('.inner-wrapper-link');

// for (let i = 0; i < productLinks.length; i++) {
//   const productLink = productLinks[i];
//   productLink.addEventListener('mouseenter', (e) => {
//     productLink.parentElement.parentElement
//       .querySelector('img')
//       .classList.add('scalling-image');
//   });
//   productLink.addEventListener('mouseleave', (e) => {
//     productLink.parentElement.parentElement
//       .querySelector('img')
//       .classList.remove('scalling-image');
//   });
// }

// function component() {
//   const element = document.createElement('div');
//   const btn = document.createElement('button');

//   element.innerHTML = _.join(['Hello', 'webpack'], ' ');

//   btn.innerHTML = 'Click me and check the console!';
//   btn.onclick = printMe;

//   element.appendChild(btn);

//   return element;
// }

// document.body.appendChild(component());
// filter range sliders
(function () {
  const parent = document.querySelector('.range-slider-pressure');
  if (!parent) return;

  const rangeS = parent.querySelectorAll('.pressure-range');
  const numberS = parent.querySelectorAll('.pressure-range-number');

  rangeS.forEach(function (el) {
    el.oninput = function () {
      let slide1 = parseFloat(rangeS[0].value);
      let slide2 = parseFloat(rangeS[1].value);

      if (slide1 > slide2) {
        [slide1, slide2] = [slide2, slide1];
        // var tmp = slide2;
        // slide2 = slide1;
        // slide1 = tmp;
      }

      numberS[0].value = slide1;
      numberS[1].value = slide2;
    };
  });

  numberS.forEach(function (el) {
    el.oninput = function () {
      const number1 = parseFloat(numberS[0].value);
      const number2 = parseFloat(numberS[1].value);

      if (number1 > number2) {
        const tmp = number1;
        numberS[0].value = number2;
        numberS[1].value = tmp;
      }

      rangeS[0].value = number1;
      rangeS[1].value = number2;
    };
  });
})();

(function () {
  const parent = document.querySelector('.range-slider-temp');
  if (!parent) return;

  const rangeS = parent.querySelectorAll('.temp-range');
  const numberS = parent.querySelectorAll('.temp-range-number');

  rangeS.forEach(function (el) {
    el.oninput = function () {
      let slide1 = parseFloat(rangeS[0].value);
      let slide2 = parseFloat(rangeS[1].value);

      if (slide1 > slide2) {
        [slide1, slide2] = [slide2, slide1];
        // var tmp = slide2;
        // slide2 = slide1;
        // slide1 = tmp;
      }

      numberS[0].value = slide1;
      numberS[1].value = slide2;
    };
  });

  numberS.forEach(function (el) {
    el.oninput = function () {
      const number1 = parseFloat(numberS[0].value);
      const number2 = parseFloat(numberS[1].value);

      if (number1 > number2) {
        const tmp = number1;
        numberS[0].value = number2;
        numberS[1].value = tmp;
      }

      rangeS[0].value = number1;
      rangeS[1].value = number2;
    };
  });
})();

const filterForm = document.querySelector('.wrapper-fast-access-filter');
if (filterForm) {
  const inputs = filterForm.querySelectorAll('input');
  inputs.forEach((input) => {
    input.addEventListener('change', (e) => {
      filter(input);
    });
  });
}



// WEBPACK FOOTER //
// ./public/javascripts/controltak.js